<template>
  <v-container fluid class="hide headerBG" style="min-height: 100vh">
    <v-btn fixed left class="print-hidden white--text ptsColor" @click="goBack">
      <v-icon left>reply</v-icon>
      <span class="mt-1">{{$t('return')}}</span>
    </v-btn>
    <v-btn
      icon
      large
      fixed
      right
      @click="printContent"
      color="amber darken-2"
      class="print-hidden white--text"
    >
      <v-icon>print</v-icon>
    </v-btn>
    <v-layout wrap mt-5 class="hide">
      <v-flex class="hide xs12" style="display:flex;justify-content: center;">
        <slot name="pages"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  props: {
    landscape: {
      default: false
    }
  },
  data() {
    return {
      fab: true,
      print: true
    };
  },
  methods: {
    rotate(landscape = false) {
      var css = landscape
          ? "@page { size: A4 landscape;margin: 0.2cm; }"
          : "@page { size: A4 portrait;margin: 0.2cm; }",
        head = document.head || document.getElementsByTagName("head")[0],
        style = document.createElement("style");

      style.type = "text/css";
      style.media = "print";

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      head.appendChild(style);
    },
    printContent() {
      if (this.landscape) this.rotate(true);
      else this.rotate(false);

      window.print();
    },
    goBack() {
      this.$emit("reset");
    }
  },
  beforeDestroy() {
    this.rotate(false);
  }
};
</script>
<style>
.headerBG {
  background: url("../../assets/images/slant-repeat.svg") no-repeat;
  background-size: 100%;
}

@page {
  @bottom-right {
    content: counter(page) " of " counter(pages);
  }
}

@media all {
  .page-break {
    display: none;
  }
}

@media print {
  .page-break {
    display: block;
    page-break-inside: avoid;
    page-break-after: always;
  }

  @page {
    size: A4;
    margin: 0.2cm;
  }

  .print-hidden {
    display: none;
  }

  .headerBG {
    background: none;
  }

  .hide {
    padding: 0 !important;
    margin: 0 !important;
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
}
</style>